import { render, staticRenderFns } from "./DataCorrectionTab.vue?vue&type=template&id=66702bca&scoped=true&"
import script from "./DataCorrectionTab.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionTab.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionTab.vue?vue&type=style&index=0&id=66702bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66702bca",
  null
  
)

export default component.exports